var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 33.054 74.04"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51 41.69a4.683 4.683 0 003.37 4.45l14.98 4.01A11.06 11.06 0 0133 60.79a13.299 13.299 0 01-13.24 13.25h-6.52A13.297 13.297 0 010 60.79v-8.14a15.994 15.994 0 006.62 4.02v4.12a6.577 6.577 0 006.62 6.62h6.52a6.577 6.577 0 006.62-6.62 4.278 4.278 0 00-.9-2.64 4.383 4.383 0 00-2.36-1.59L8.14 52.54a10.988 10.988 0 012.82-21.6h10.97a4.395 4.395 0 100-8.79H10.96v-6.62h10.97a4.473 4.473 0 004.45-4.45 4.32 4.32 0 00-4.45-4.35H6.62v20.41A16.057 16.057 0 000 31.16V0h22.04a10.965 10.965 0 017.81 18.67A10.777 10.777 0 0133 26.38a10.934 10.934 0 01-10.96 10.97H10.96a4.451 4.451 0 00-4.45 4.34z"
  })));
};

export default SvgLogo;